import { DefaultValue } from "recoil";
import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";

export const BASE = {
    path: `${lpcoEnvs.base}/lpco/hscd/itm`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/hscd/itm`,
    vrfnApi: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/hscd/itm/vrfn`,
    nodes: [
        // TODO 라벨 처리 필요
        { path: "/", label: "L_ESW" },
        { path: "/lpco/hscd/itm", label: "L_HS_CD" },
        { path: "/lpco/hscd/itm", label: "L_RGSR" },
    ],
};

export const URLS = {
    osci0204001s: `${BASE.path}/osci0204001s`,
    osci0204002q: `${BASE.path}/osci0204002q`,
    osci0204003s: `${BASE.path}/osci0204003s`,
    osci0204004s: `${BASE.path}/osci0204004s`,
};
export const APIS = {
    getOgaHsCdList: (ogaCd: any) => {
        //  /api/v1/osci/lpco/hscd/itm/oga-hs/{ogaCd}
        return api.get(`${BASE.api}/oga-hs/${ogaCd}`);
    },
    createHsAppInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    updateHsAppInfo: (hsAppId: any, data: any) => {
        return api.put(`${BASE.api}/${hsAppId}`, {
            ...data,
        });
    },
    getHsAppList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getHsAppInfo: (hsAppId: any) => {
        return api.get(`${BASE.api}/${hsAppId}`, {});
    },
    deleteHsAppInfo: (hsAppId: any) => {
        return api.delete(`${BASE.api}/${hsAppId}`, {});
    },
    getHsAppAprvHistList: (hsAppId: any) => {
        return api.get(`${BASE.vrfnApi}/aprv-hist/${hsAppId}`, {});
    },
};

export const SF_SCHEMA_SRCH_HS_APP: TFormSchema = {
    id: "form_cscl",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        orgNm: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        srchOrgChpnNm: {
            type: "text",
            label: "L_OGA_OFCR_NM",
        } /* OGA Name !== OGA 명 ==!*/,
        srchOrgChpnId: {
            type: "text",
            label: "L_OGA_OFCR",
        } /* OGA Name !== OGA 명 ==!*/,
        srchHsAppNo: {
            type: "text",
            label: "L_APP_NO",
        } /* Application No !== 신청서 번호 ==!*/,
        srchOrgChpnTelno: {
            type: "text",
            label: "L_OGA_OFCR_TELNO",
            required: true,
        } /* OGA Officer Tel No. */,
        srchOrgChpnEml: {
            type: "text",
            label: "L_OGA_OFCR_EML",
            required: true,
        } /* OGA Officer Email */,
        srchPrcssStatCd: {
            type: "select",
            label: "L_STTS",
            area: "comnCd",
            comnCd: "OSC0132",
        } /* Status !== 상태 ==!*/,
        srchSbmtDtm: {
            type: "daterange",
            label: "L_SBMT_DT",

            start: { name: "srchSbmtStrtDtm" },
            end: { name: "srchSbmtEndDtm" },
        },
        srchAprvDtm: {
            type: "daterange",
            label: "L_APRVD_DT",

            start: { name: "srchAprvStrtDtm" },
            end: { name: "srchAprvEndDtm" },
        },
    },
};

export const SF_SCHEMA_HS_APP: TFormSchema = {
    id: "form_hsApp",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        orgNm: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        orgChpnNm: {
            type: "text",
            label: "L_OGA_OFCR_NM",
            edit: false,
        } /* OGA Name !== OGA 명 ==!*/,
        orgChpnId: {
            type: "text",
            label: "L_OGA_OFCR",
            edit: false,
        } /* OGA Name !== OGA 명 ==!*/,
        hsAppNo: {
            type: "text",
            label: "L_APP_NO",
            edit: false,
        } /* Application No !== 신청서 번호 ==!*/,
        orgChpnTelno: {
            type: "text",
            label: "L_OGA_OFCR_TELNO",
            required: true,
            edit: true,
        } /* OGA Officer Tel No. */,
        orgChpnEml: {
            type: "text",
            label: "L_OGA_OFCR_EML",
            required: true,
            edit: true,
        } /* OGA Officer Email */,
        appDt: {
            type: "date",
            label: "L_APP_DT",
            edit: false,
        } /* Application Date !== 신청서 일자 ==!*/,
        aprvDt: {
            type: "date",
            label: "L_APRVD_DT",
            edit: false,
        } /* Approval Date !== 승인 일자 ==! */,
        prcssStatCd: {
            type: "select",
            label: "L_STTS",
            edit: false,
            area: "comnCd",
            comnCd: "OSC0132",
        } /* Status !== 상태 ==!*/,
    },
};

export const SG_APP_HS_CODE_LIST: TGridSchema = {
    id: "grid_rgsrHscodeList",
    options: {
        pagination: "in",
        edit: true,
        checkbox: true,
        radio: false,
        index: true,
        height: 450,
        importExcel: true,
    },
    head: [
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: 350 }] },
        { cells: [{ header: "L_DTL_DESC", binding: "godsDesc", width: "*" }] },
        { cells: [{ header: "L_INSC_TRGT_YN", binding: "inscTrgtYn", width: 100 }] },
        { cells: [{ header: "L_INSC_TRGT", binding: "imexTpCd", width: 150 }] },
        { cells: [{ header: "L_VLD_STRT_DT", binding: "appdStrtDt", width: 150 }] },
        { cells: [{ header: "L_VLD_END_DT", binding: "appdEndDt", width: 150 }] },
    ],
    body: [
        {
            cells: [
                { binding: "hsCd", type: "code", area: "hsCd", required: true, excel: "A" },
            ] /* Hs code !== Hs 코드 ==!*/,
        },
        {
            cells: [{ binding: "godsDesc", excel: "B" }] /* Detailed Description !== 설명 ==!*/,
        },
        {
            cells: [
                {
                    binding: "inscTrgtYn",
                    type: "select",
                    area: "comnCd",
                    comnCd: "OSC0134",
                    required: true,
                    excel: "C",
                },
            ],
        },
        {
            cells: [
                {
                    binding: "imexTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "OSC0133",
                    select: true,
                    excel: "D",
                },
            ] /* Inspection Target !== 검사대상 ==!*/,
        },

        {
            cells: [
                { binding: "appdStrtDt", type: "date", required: true, excel: "E" },
            ] /**  Valid Start Date !== 유효_시작_일자 ==! */,
        },
        {
            cells: [
                { binding: "appdEndDt", type: "date", required: true, excel: "F" },
            ] /**  Valid End Date !== 유효_종료_일자 ==! */,
        },
    ],
};

export const SG_APP_HS_CODE_LIST_R: TGridSchema = {
    id: "grid_rgsrHscodeListR",
    options: { pagination: "in", edit: false, checkbox: false, radio: false, index: true, height: 500 },
    head: [
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: 350 }] },
        { cells: [{ header: "L_DTL_DESC", binding: "godsDesc", width: "*" }] },
        { cells: [{ header: "L_INSC_TRGT_YN", binding: "inscTrgtYn", width: 100 }] },
        { cells: [{ header: "L_INSC_TRGT", binding: "imexTpCd", width: 150 }] },
        { cells: [{ header: "L_VLD_STRT_DT", binding: "appdStrtDt", width: 150 }] },
        { cells: [{ header: "L_VLD_END_DT", binding: "appdEndDt", width: 150 }] },
    ],
    body: [
        {
            cells: [
                { binding: "hsCd", type: "code", area: "hsCd", required: true, align: "left" },
            ] /* Hs code !== Hs 코드 ==!*/,
        },
        {
            cells: [{ binding: "godsDesc", align: "left" }] /* Detailed Description !== 설명 ==!*/,
        },
        {
            cells: [{ binding: "inscTrgtYn", type: "select", area: "comnCd", comnCd: "OSC0134", required: true }],
        },
        {
            cells: [
                {
                    binding: "imexTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "OSC0133",
                    select: true,
                },
            ] /* Inspection Target !== 검사대상 ==!*/,
        },
        {
            cells: [
                { binding: "appdStrtDt", type: "date", required: true },
            ] /**  Valid Start Date !== 유효_시작_일자 ==! */,
        },
        {
            cells: [
                { binding: "appdEndDt", type: "date", required: true },
            ] /**  Valid End Date !== 유효_종료_일자 ==! */,
        },
    ],
};

export const SG_SRCH_HS_CODE_LIST: TGridSchema = {
    id: "grid_srchHscodeList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true, height: 400 },
    head: [
        { cells: [{ header: "L_APP_NO", binding: "hsAppNo", width: 150 }] },
        { cells: [{ header: "L_OGA", binding: "orgCd", width: 100 }] },
        { cells: [{ header: "L_OGA_OFCR_NM", binding: "orgChpnNm", width: "*" }] },
        { cells: [{ header: "L_SBMT_DT", binding: "sbmtDtm", width: 90 }] },
        { cells: [{ header: "L_APRVD_DT", binding: "aprvDtm", width: 90 }] },
        { cells: [{ header: "L_ITM_CNT_1", binding: "hsCnt", width: 70 }] },
        { cells: [{ header: "L_STTS", binding: "prcssStatCd", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "hsAppNo" }] /* Application No !== 신청서 번호 ==!*/,
        },
        {
            cells: [{ binding: "orgCd" }] /* OGA !== OGA ==!*/,
        },
        {
            cells: [{ binding: "orgChpnNm", align: "left" }],
        },
        {
            cells: [{ binding: "sbmtDtm", type: "date" }] /* Application Date !== 제출 일자 ==!*/,
        },
        {
            cells: [{ binding: "aprvDtm", type: "date" }] /* Approval Date !== 승인 일자 ==! */,
        },
        {
            cells: [{ binding: "hsCnt" }] /* Number of Items !== 물품 개수 ==!*/,
        },
        {
            cells: [
                { binding: "prcssStatCd", type: "select", area: "comnCd", comnCd: "OSC0132" },
            ] /* Status !== 상태 ==!*/,
        },
    ],
};

export const SG_HS_APRV_HIST_LIST: TGridSchema = {
    id: "grid_hsAprvHistList",
    options: { pagination: false, edit: false, checkbox: false, radio: false, index: "DESC", height: 300 },
    head: [
        { cells: [{ header: "L_OGA", binding: "orgNm", width: "*" }] },
        { cells: [{ header: "L_OFCR_ROLE", binding: "asnmtOfcrTpCd", width: "*" }] },
        { cells: [{ header: "L_PRCSS_DT", binding: "ofcrPrcssDtm", width: "*" }] },
        { cells: [{ header: "L_PRCSS_STAT", binding: "prcssStatCd", width: "*" }] },
        { cells: [{ header: "L_VRFN_RSLT", binding: "prcssRsnCn", width: "*" }] },
        { cells: [{ header: "T_RMRK", binding: "rmrk", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "orgNm" }],
        },
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "OSC0119",
                    excludes: ["AC", "MA", "DT", "LC", "CC"],
                },
            ],
        },
        {
            cells: [{ binding: "ofcrPrcssDtm", type: "datetime" }],
        },
        {
            cells: [{ binding: "prcssStatCd", type: "select", area: "comnCd", comnCd: "OSC0131" }],
        },
        {
            cells: [{ binding: "prcssRsnCn", type: "textarea" }],
        },
        {
            cells: [{ binding: "rmrk", type: "textarea" }],
        },
    ],
};
